import '../assets/Styles/LoginCSS/Login.css';
import React from 'react';
import Login from '../components/Login/login.js';


function LoginPage() {

    return (
        <Login />
    );
}

export default LoginPage;
